import CONFIG from "../../../../../config/config";

const CHATBOT_TEMPLATES = [
    {
        slug: "faq-bot",
        visible: true,
        enabled: true,
        name: "FAQ Bot",
        shortDescription: "Answer frequently asked questions with a chatbot and save your time.",
        description:
            "Automate frequently asked questions about order and account issues.\n\n**Key features:**\n* Provide support 24/7/365.\n* Answer common questions about order,tracking and account issues.\n* Redirect users to the related product  and store pages they're looking for to improve customer experience.",
        imageUrl: "/static/img/chatbot/faq-bot.png",
        integrations: ["supsis-widget", "whatsapp", "telegram"],
        categories: ["basic", "automation"],
        updatedAt: "2022-08-23T00:00:00.000Z",
    },
    {
        slug: "us-polo-assn",
        visible: CONFIG.AKINON.enabledReal,
        enabled: true,
        name: "US Polo ASSN - Dijital Asistan v1",
        shortDescription: "Müşterilere sipariş ve benzeri konularda yardımcı olmak için tasarlanmıştır.",
        description:
            "Automate frequently asked questions about order and account issues.\n\n**Key features:**\n* Provide support 24/7/365.\n* Answer common questions about order,tracking and account issues.\n* Redirect users to the related product  and store pages they're looking for to improve customer experience.",
        imageUrl: "/static/img/chatbot/us-polo-assn.png",
        integrations: ["supsis-widget", "whatsapp", "telegram"],
        categories: ["basic", "automation", "featured"],
        updatedAt: "2022-11-10T00:00:00.000Z",
    },
    {
        slug: "pierre-cardin",
        visible: CONFIG.AKINON.enabledReal,
        enabled: true,
        name: "Pierre Cardin - Dijital Asistan v1",
        shortDescription: "Müşterilere sipariş ve benzeri konularda yardımcı olmak için tasarlanmıştır.",
        description:
            "Automate frequently asked questions about order and account issues.\n\n**Key features:**\n* Provide support 24/7/365.\n* Answer common questions about order,tracking and account issues.\n* Redirect users to the related product  and store pages they're looking for to improve customer experience.",
        imageUrl: "/static/img/chatbot/pierre-cardin.png",
        integrations: ["supsis-widget", "whatsapp", "telegram"],
        categories: ["basic", "automation", "featured"],
        updatedAt: "2022-11-10T00:00:00.000Z",
    },
    {
        slug: "cacharel",
        visible: CONFIG.AKINON.enabledReal,
        enabled: true,
        name: "Cacharel - Dijital Asistan v1",
        shortDescription: "Müşterilere sipariş ve benzeri konularda yardımcı olmak için tasarlanmıştır.",
        description:
            "Automate frequently asked questions about subscription and account issues.\n\n**Key features:**\n* Provide support 24/7/365.\n* Answer common questions about subscription and account issues.\n* Redirect users to the articles and pages they're looking for to improve customer experience.",
        imageUrl: "/static/img/chatbot/cacharel.png",
        integrations: ["supsis-widget", "whatsapp", "telegram"],
        categories: ["basic", "automation", "featured"],
        updatedAt: "2022-11-10T00:00:00.000Z",
    },
    {
        slug: "call-scheduling",
        visible: true,
        enabled: true,
        name: "Call Scheduling Bot",
        shortDescription: "Let customers call you at the click of a button or schedule a call for later.",
        description:
            "Let customers call you by using a chatbot or schedule a call for later.\n\n**Key features:**\n* Inform customers about your working hours\n* Make a call directly from the Chat Widget\n* Collect contact information (name, e-mail, phone number, additional message)\n* Schedule a call (pick a date and time)",
        imageUrl: "/static/img/chatbot/schedule-a-call.png",
        integrations: ["supsis-widget", "whatsapp", "telegram"],
        categories: ["basic", "automation"],
        updatedAt: "2022-08-23T00:00:00.000Z",
    },
    {
        slug: "online-quiz-bot",
        visible: true,
        enabled: true,
        name: "Online Quiz Bot",
        shortDescription: "Engage your customers with a chatbot quiz tailored to your needs.",
        description:
            "Engage your customers with a chatbot quiz tailored to your needs.\n\n**Key features:**\n*  Ask customers five questions and display their score\n* Share tips via the Show tip button\n* Show users an explanation if they get the answer wrong\n* Use the template and its logic to create more questions\n* Share coupon codes",
        imageUrl: "/static/img/chatbot/online-quiz-bot.png",
        integrations: ["supsis-widget", "whatsapp", "telegram"],
        categories: ["basic", "featured", "automation"],
        updatedAt: "2022-08-23T00:00:00.000Z",
    },
    {
        slug: "online-quiz-bot-tr",
        visible: true,
        enabled: true,
        name: "Online Quiz Bot (Turkish)",
        shortDescription: "Engage your customers with a chatbot quiz tailored to your needs.",
        description:
            "Engage your customers with a chatbot quiz tailored to your needs.\n\n**Key features:**\n*  Ask customers five questions and display their score\n* Share tips via the Show tip button\n* Show users an explanation if they get the answer wrong\n* Use the template and its logic to create more questions\n* Share coupon codes",
        imageUrl: "/static/img/chatbot/online-quiz-bot-iki.svg",
        integrations: ["supsis-widget", "whatsapp", "telegram"],
        categories: ["basic", "featured", "automation"],
        updatedAt: "2023-09-23T00:00:00.000Z",
    },

    {
        slug: "e-commerce",
        visible: true,
        enabled: true,
        name: "E-commerce Bot",
        shortDescription: "Improve customer experience to grow your sales.",
        description:
            "Guide customers through the whole buying process. Improve customer experience and boost sales.\n\n**Key tasks:**\n* Promote special offers\n* Add items to carts\n* Process orders\n* Provide support 24/7",
        imageUrl: "/static/img/chatbot/e-commerce.png",
        integrations: ["supsis-widget", "whatsapp", "telegram"],
        categories: ["basic", "featured"],
        updatedAt: "2022-08-23T00:00:00.000Z",
    },
    {
        slug: "package-tracking-bot",
        visible: true,
        enabled: true,
        name: "Package Tracking Bot",
        shortDescription: "Let customers check the delivery status in the chat window",
        description:
            "Do you ship packages to your customers? Enable them to check the current status of their deliveries while chatting with a chatbot.\n\n**Key features:**\n* An advanced system that verifies the delivery status\n* Custom bot responses relevant to the package status\n* Filters that route messages",
        imageUrl: "/static/img/chatbot/package-tracking.png",
        integrations: ["supsis-widget", "whatsapp", "telegram"],
        categories: ["basic", "automation", "featured"],
        updatedAt: "2023-04-07T00:00:00.000Z",
    },
    {
        slug: "university-bot",
        visible: true,
        enabled: true,
        name: "University Bot",
        shortDescription: "Automate your communication and admission process.",
        description:
            "Engage and support candidates on your website and social media pages. Streamline your admission process.\n\n**Key features:**\n* Explain admission procedures\n* Promote courses & open days\n* Inform users about the admission deadlines\n* Gather questions using a conversational contact form\n* Make a call directly from the chat widget",
        imageUrl: "/static/img/chatbot/university.png",
        integrations: ["supsis-widget", "whatsapp", "telegram"],
        categories: ["basic", "automation", "featured"],
        updatedAt: "2022-08-23T00:00:00.000Z",
    },
    {
        slug: "restaurant-bot",
        visible: true,
        enabled: true,
        name: "Restaurant Bot",
        shortDescription: "Automate taking orders & making reservations. Support customers 24/7.",
        description:
            "Automate taking orders and making reservations to focus on customers you are currently serving.\n\n**Key features:**\n* Present your restaurant menu\n* Take and processes orders\n* Pass orders automatically to your backend using webhooks\n* Manage table reservations\n* Provide contact information",
        imageUrl: "/static/img/chatbot/restaurant.png",
        integrations: ["supsis-widget", "whatsapp", "telegram"],
        categories: ["basic", "automation", "featured"],
        updatedAt: "2022-08-23T00:00:00.000Z",
    },
    {
        slug: "sales-bot",
        visible: true,
        enabled: true,
        name: "Sales Bot",
        shortDescription: "Sell your products directly from the chat window",
        description:
            "Support customers using a smart chatbot. Promote your products and improve customer experience to make more sales.\n\n**Key features:**\n* Promote special offers, holiday deals & bestsellers\n* Take and process orders\n* Answer common questions\n* Track packages\n* Let customers leave a message in the chat window",
        imageUrl: "/static/img/chatbot/sales-bot.png",
        integrations: ["supsis-widget", "whatsapp", "telegram"],
        categories: ["basic", "automation", "featured", "new"],
        updatedAt: "2023-04-07T00:00:00.000Z",
    },
    {
        slug: "recruitment-bot",
        visible: true,
        enabled: true,
        name: "Recruitment Bot",
        shortDescription: "Improve customer experience to grow your sales.",
        description:
            "Automate sourcing candidates and answering common questions to speed up your hiring process.\n\n**Key features:**\n* Promote open positions\n* Collect contact information\n* Generate leads\n* Answer repetitive questions",
        imageUrl: "/static/img/chatbot/recruitment-bot.png",
        integrations: ["supsis-widget", "whatsapp", "telegram"],
        categories: ["basic", "automation", "featured"],
        updatedAt: "2022-08-23T00:00:00.000Z",
    },
    {
        slug: "the-coffee-shop",
        visible: true,
        enabled: true,
        name: "The Coffee Shop",
        shortDescription: "Present your shop’s offers and collect orders in the chat window.",
        description:
            "Present your shop’s offers and collect orders in the chat window.\n\n**Key features:**\n* Present your menu\n* Take orders",
        imageUrl: "/static/img/chatbot/coffee-shop.png",
        integrations: ["supsis-widget", "whatsapp", "telegram"],
        categories: ["basic", "featured"],
        updatedAt: "2022-08-23T00:00:00.000Z",
    },
    {
        slug: "real-estate-bot",
        visible: true,
        enabled: true,
        name: "Real Estate Bot",
        shortDescription: "Promote your rental properties and find tenants quickly.",
        description:
            "Connect with home sellers & buyers. Automate your rental listing process and qualify leads in the chat window.\n\n**Key features:**\n* Promote rental properties\n* Collect leads in the chat window\n* Schedule calls with prospects\n* Provide your contact details\n* Let customers list their properties easily",
        imageUrl: "/static/img/chatbot/real-estate-bot.png",
        integrations: ["supsis-widget", "whatsapp", "telegram"],
        categories: ["basic", "automation", "featured"],
        updatedAt: "2022-08-23T00:00:00.000Z",
    },
    {
        slug: "customer-service-bot",
        visible: true,
        enabled: true,
        name: "Customer Service Bot",
        shortDescription: "Automate repetitive queries and give your customers instant answers 24/7/365.",
        description:
            "Automate repetitive sales and support queries and give your customers instant, and consistent answers 24/7/365.\n\n**With Customer Service bot you’ll be able to:**\n* Navigate customers through the most important sections of your website/help center/blog.\n* Share sales and support information.\n* Start a call directly from within ChatBot.",
        imageUrl: "/static/img/chatbot/customer-satisfaction-bot.png",
        integrations: ["supsis-widget", "whatsapp", "telegram"],
        categories: ["basic", "automation", "featured"],
        updatedAt: "2023-04-07T00:00:00.000Z",
    },
    {
        slug: "faq-chat-bot",
        visible: true,
        enabled: true,
        name: "FAQ BOT",
        shortDescription:
            "Automate frequently asked questions about subscription and account issues.  Key features:  Provide support 24/7/365. Answer common questions about subscription and account issues. Redirect users to the articles and pages they're looking for to improve customer experience.",
        description:
            "Automate repetitive sales and support queries and give your customers instant, and consistent answers 24/7/365.\n\n**With Customer Service bot you’ll be able to:**\n* Navigate customers through the most important sections of your website/help center/blog.\n* Share sales and support information.\n* Start a call directly from within ChatBot.",
        imageUrl: "/static/img/chatbot/idea-svgrepo-com.svg",
        integrations: ["supsis-widget", "whatsapp", "telegram"],
        categories: ["basic", "automation", "featured"],
        updatedAt: "2023-04-07T00:00:00.000Z",
    },
    {
        slug: "offline-bot",
        visible: true,
        enabled: true,
        name: "Offline Bot",
        shortDescription: "Belirtilen süre zarfında yanıt alınamadığında devreye giren bir bot.",
        description: "Offline Bot, belirli bir süre içinde kullanıcılardan gelen sorulara yanıt alınamadığında devreye giren bir otomatik sistemdir. Bu bot, kullanıcılara beklenen yanıt süresi içinde destek alamadıklarında yardımcı olmak amacıyla tasarlanmıştır. Temel özellikleri şunlardır:\n\n* Kullanıcılara temel bilgileri sağlama.\n* İlgili bağlantılara yönlendirme.\n* Diğer iletişim kanallarına geçiş için rehberlik.",
        imageUrl: "/static/img/chatbot/offline-icon.svg",
        integrations: ["supsis-widget", "whatsapp", "telegram"],
        categories: ["basic", "automation", "featured"],
        updatedAt: "2023-04-07T00:00:00.000Z",
    },
    {
        slug: "restaurant-bot-tr",
        visible: true,
        enabled: true,
        name: "Restaurant Bot (Turkish)",
        shortDescription: "Restoran işletmeleri için özel olarak tasarlanmış bir sohbet botu.",
        description: "Restaurant Bot (Turkish), restoran işletmelerine özel olarak geliştirilmiş bir sohbet botudur. Temel amacı, müşterilere hızlı ve etkileşimli bir şekilde hizmet sunmak ve restoran deneyimini geliştirmektir. Bu botun öne çıkan özellikleri şunlardır:\n\n* Menüyü gösterme ve önerilerde bulunma.\n* Rezervasyon alımını kolaylaştırma.\n* Çalışma saatleri ve konum bilgisi sağlama.\n* Sıkça sorulan soruları yanıtlama.",
        imageUrl: "/static/img/chatbot/restaurant-icon-ai.svg",
        integrations: ["supsis-widget", "whatsapp", "telegram"],
        categories: ["basic", "automation", "featured"],
        updatedAt: "2023-04-07T00:00:00.000Z",
    },
    {
        slug: "offline-bot-en",
        visible: true,
        enabled: true,
        name: "Offline Bot (English)",
        shortDescription: "A bot that comes into play when a response cannot be obtained within a specified time.",
        description: "The Offline Bot (English) is an automated system that comes into play when responses cannot be obtained within a specified time frame. This bot is designed to assist users when they cannot get support within the expected response time. Its key features include:\n\n* Providing users with basic information.\n* Directing users to relevant links.\n* Guiding users for transitioning to other communication channels.",
        imageUrl: "/static/img/chatbot/offline-icon.svg",
        integrations: ["supsis-widget", "whatsapp", "telegram"],
        categories: ["basic", "automation", "featured"],
        updatedAt: "2023-04-07T00:00:00.000Z",
    },
    {
        slug: "real-estate-bot-tr",
        visible: true,
        enabled: true,
        name: "Real Estate Bot (Turkish)",
        shortDescription: "Gayrimenkul sektörü için özel olarak tasarlanmış bir sohbet botu.",
        description: "Real Estate Bot (Turkish), gayrimenkul sektörüne özel olarak geliştirilmiş bir sohbet botudur. Temel amacı, kullanıcılara hızlı ve etkileşimli bir şekilde gayrimenkul ile ilgili bilgiler sunmak ve mülk satın alma veya kiralama sürecini kolaylaştırmaktır. Bu botun öne çıkan özellikleri şunlardır:\n\n* Satılık veya kiralık mülkleri listeleme.\n* Kullanıcı taleplerine uygun önerilerde bulunma.\n* Gayrimenkul finansmanı ve ödeme seçenekleri hakkında bilgi verme.\n* İlgili belgelere erişim sağlama.",
        imageUrl: "/static/img/chatbot/real-estate-house.svg",
        integrations: ["supsis-widget", "whatsapp", "telegram"],
        categories: ["basic", "automation", "featured"],
        updatedAt: "2023-04-07T00:00:00.000Z",
    },
    {
        slug: "university-bot-tr",
        visible: true,
        enabled: true,
        name: "University Bot (Turkish)",
        shortDescription: "Eğitim sektörüne özel olarak tasarlanmış bir sohbet botu.",
        description: "University Bot (Turkish), eğitim sektörüne özel olarak geliştirilmiş bir sohbet botudur. Temel amacı, öğrencilere ve potansiyel öğrencilere hızlı ve etkileşimli bir şekilde üniversite ile ilgili bilgiler sunmak ve eğitim sürecini kolaylaştırmaktır. Bu botun öne çıkan özellikleri şunlardır:\n\n* Fakülteler ve programlar hakkında bilgi verme.\n* Başvuru sürecini yönlendirme ve destekleme.\n* Burs ve finansman seçenekleri konusunda rehberlik.\n* Kampüs turları ve etkinlik bilgileri sağlama.",
        imageUrl: "/static/img/chatbot/university-academy-schoo.svg",
        integrations: ["supsis-widget", "whatsapp", "telegram"],
        categories: ["basic", "automation", "featured"],
        updatedAt: "2023-04-07T00:00:00.000Z",
    },
    {
        slug: "recruitment-bot-tr",
        visible: true,
        enabled: true,
        name: "Recruitment Bot (Turkish)",
        shortDescription: "İnsan kaynakları süreçlerini optimize etmek amacıyla tasarlanmış bir sohbet botu.",
        description: "Recruitment Bot (Turkish), işe alım süreçlerini optimize etmek amacıyla özel olarak tasarlanmış bir sohbet botudur. Bu botun temel amacı, iş başvurularını hızlı ve etkileşimli bir şekilde yönetmek, adaylara bilgi vermek ve işe alım sürecini daha verimli hale getirmektir. Öne çıkan özellikleri şunlardır:\n\n* İş ilanları hakkında bilgi verme ve başvuru sürecini başlatma.\n* Başvuru durumu sorgulama ve güncel bilgileri sunma.\n* Mülakat tarihleri ve yerleri hakkında bilgilendirme.\n* Adaylara genel şirket bilgisi sağlama.",
        imageUrl: "/static/img/chatbot/recruitment.svg",
        integrations: ["supsis-widget", "whatsapp", "telegram"],
        categories: ["basic", "automation", "featured"],
        updatedAt: "2023-04-07T00:00:00.000Z",
    },
    {
        slug: "package-tracking-bot-tr",
        visible: true,
        enabled: true,
        name: "Package Tracking Bot (Turkish)",
        shortDescription: "Let customers check the delivery status in the chat window",
        description:
            "Do you ship packages to your customers? Enable them to check the current status of their deliveries while chatting with a chatbot.\n\n**Key features:**\n* An advanced system that verifies the delivery status\n* Custom bot responses relevant to the package status\n* Filters that route messages",
        imageUrl: "/static/img/chatbot/package-shipping-and-delivery.svg",
        integrations: ["supsis-widget", "whatsapp", "telegram"],
        categories: ["basic", "automation", "featured"],
        updatedAt: "2023-04-07T00:00:00.000Z",
    },
];

export default CHATBOT_TEMPLATES;
